module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAELSURBVHgBpZPbjcIwEEXveFNASnAqSErIVrJ8rkRW2g4IHYAE/1ACFSA6gAqcEvKNgGEcwsMB8uJKkSfWzNG1Zww0iLOh4SxZN+WpWoj5GwCkJYzZJHFvEOg0uscY9QI9uLmq1pVq5aaFK2Lz7wN7DXxFgg1lzwdzJGv0pmYrXwbGroxzwNuS7UrlCD3EmRLyBp+KaUXFaoYLEP2gj5iXFMwHxWXbQJyN0VVSU9RahrNvkrRpXlzILL3+VtrvTdBabm4FdIjQWoe4BsQdQKxrQKRfVOR2Tp52lQrfgwihA7CdZC8AH7/LruZ3Q657D678EjC1l0nBJL9BgZTN70KeUto4c5KoL28PnfPOBVJjyPRZKUMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Ico_Star.png
// module id = 693
// module chunks = 0